/**
 * Build an absolute in-app URL that honors the server-injected base path — the
 * same `data-base-path` attribute App.jsx feeds to React Router as its
 * `<Router basename>`. Stripe success/cancel/return URLs must be ABSOLUTE and
 * include the base path; without it, a subpath-hosted deployment (e.g. served
 * under `/hestia`) redirects to the wrong location after checkout/portal.
 *
 * @param {string} path - app path beginning with "/" (e.g. "/subscription/success")
 * @returns {string} absolute URL, e.g. "https://host/hestia/subscription/success"
 */
export function appUrl(path) {
  const base = (document.getElementById('root')?.getAttribute('data-base-path') || '').replace(/\/$/, '');
  return `${window.location.origin}${base}${path}`;
}
